// Mock data for teacher scheduled lessons and duties - SAT V4 Zone
import type { TeacherDuty, TeacherScheduledLesson } from '../components/TeacherSlotCard';

// Mock scheduled lessons for demonstration purposes
// This maps teacherId to their scheduled lessons
export const mockTeacherScheduledLessons: Record<string, TeacherScheduledLesson[]> = {
  'teacher-001': [
    // Monday lessons
    {
      periodId: 'monday-p1',
      dayOfWeek: 'monday',
      subjectName: 'English',
      className: '7JW',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p2',
      dayOfWeek: 'monday',
      subjectName: 'English',
      className: '8AB',
      setName: 'Set 2',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'monday',
      subjectName: 'English',
      className: '9CD',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p7',
      dayOfWeek: 'monday',
      subjectName: 'English',
      className: '10EF',
      setName: 'Set 3',
      subjectColor: '#4CAF50',
    },
    // Tuesday lessons
    {
      periodId: 'monday-p1',
      dayOfWeek: 'tuesday',
      subjectName: 'English',
      className: '7GH',
      setName: 'Set 2',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'tuesday',
      subjectName: 'English',
      className: '8IJ',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p8',
      dayOfWeek: 'tuesday',
      subjectName: 'English',
      className: '11KL',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
    // Wednesday lessons
    {
      periodId: 'monday-p2',
      dayOfWeek: 'wednesday',
      subjectName: 'English',
      className: '7JW',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'wednesday',
      subjectName: 'English',
      className: '9MN',
      setName: 'Set 2',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'wednesday',
      subjectName: 'English',
      className: '10OP',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
    // Thursday lessons
    {
      periodId: 'monday-p1',
      dayOfWeek: 'thursday',
      subjectName: 'English',
      className: '8AB',
      setName: 'Set 2',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'thursday',
      subjectName: 'English',
      className: '7QR',
      setName: 'Set 3',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p7',
      dayOfWeek: 'thursday',
      subjectName: 'English',
      className: '11ST',
      setName: 'Set 2',
      subjectColor: '#4CAF50',
    },
    // Friday lessons
    {
      periodId: 'monday-p2',
      dayOfWeek: 'friday',
      subjectName: 'English',
      className: '9CD',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'friday',
      subjectName: 'English',
      className: '10UV',
      setName: 'Set 2',
      subjectColor: '#4CAF50',
    },
    {
      periodId: 'monday-p8',
      dayOfWeek: 'friday',
      subjectName: 'English',
      className: '7WX',
      setName: 'Set 1',
      subjectColor: '#4CAF50',
    },
  ],
  'teacher-002': [
    // Monday lessons - Maths teacher
    {
      periodId: 'monday-p1',
      dayOfWeek: 'monday',
      subjectName: 'Mathematics',
      className: '10AB',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p2',
      dayOfWeek: 'monday',
      subjectName: 'Mathematics',
      className: '11CD',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'monday',
      subjectName: 'Mathematics',
      className: '9EF',
      setName: 'Set 2',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p7',
      dayOfWeek: 'monday',
      subjectName: 'Mathematics',
      className: '8GH',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    // Tuesday lessons
    {
      periodId: 'monday-p2',
      dayOfWeek: 'tuesday',
      subjectName: 'Mathematics',
      className: '10IJ',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'tuesday',
      subjectName: 'Mathematics',
      className: '7KL',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p8',
      dayOfWeek: 'tuesday',
      subjectName: 'Mathematics',
      className: '11MN',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    // Wednesday lessons
    {
      periodId: 'monday-p1',
      dayOfWeek: 'wednesday',
      subjectName: 'Mathematics',
      className: '9OP',
      setName: 'Set 2',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'wednesday',
      subjectName: 'Mathematics',
      className: '8QR',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p7',
      dayOfWeek: 'wednesday',
      subjectName: 'Mathematics',
      className: '10ST',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    // Thursday lessons
    {
      periodId: 'monday-p2',
      dayOfWeek: 'thursday',
      subjectName: 'Mathematics',
      className: '7UV',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'thursday',
      subjectName: 'Mathematics',
      className: '11WX',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    // Friday lessons
    {
      periodId: 'monday-p1',
      dayOfWeek: 'friday',
      subjectName: 'Mathematics',
      className: '8YZ',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'friday',
      subjectName: 'Mathematics',
      className: '9AB',
      setName: 'Set 2',
      subjectColor: '#2196F3',
    },
    {
      periodId: 'monday-p7',
      dayOfWeek: 'friday',
      subjectName: 'Mathematics',
      className: '10CD',
      setName: 'Set 1',
      subjectColor: '#2196F3',
    },
  ],
  'teacher-003': [
    // Science teacher with bi-weekly schedule
    {
      periodId: 'monday-p1',
      dayOfWeek: 'monday',
      week: 'A',
      subjectName: 'Science',
      className: '7EF',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p2',
      dayOfWeek: 'monday',
      week: 'A',
      subjectName: 'Science',
      className: '8GH',
      setName: 'Set 2',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'monday',
      week: 'A',
      subjectName: 'Science',
      className: '9IJ',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p1',
      dayOfWeek: 'monday',
      week: 'B',
      subjectName: 'Science',
      className: '7KL',
      setName: 'Set 2',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p2',
      dayOfWeek: 'monday',
      week: 'B',
      subjectName: 'Science',
      className: '8MN',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'monday',
      week: 'B',
      subjectName: 'Science',
      className: '9OP',
      setName: 'Set 2',
      subjectColor: '#9C27B0',
    },
    // Tuesday
    {
      periodId: 'monday-p4',
      dayOfWeek: 'tuesday',
      subjectName: 'Science',
      className: '7QR',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'tuesday',
      subjectName: 'Science',
      className: '8ST',
      setName: 'Set 2',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p7',
      dayOfWeek: 'tuesday',
      subjectName: 'Science',
      className: '9UV',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    // Wednesday
    {
      periodId: 'monday-p1',
      dayOfWeek: 'wednesday',
      subjectName: 'Science',
      className: '7WX',
      setName: 'Set 3',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p2',
      dayOfWeek: 'wednesday',
      subjectName: 'Science',
      className: '8YZ',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p8',
      dayOfWeek: 'wednesday',
      subjectName: 'Science',
      className: '9AB',
      setName: 'Set 2',
      subjectColor: '#9C27B0',
    },
    // Thursday
    {
      periodId: 'monday-p1',
      dayOfWeek: 'thursday',
      subjectName: 'Science',
      className: '7CD',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p5',
      dayOfWeek: 'thursday',
      subjectName: 'Science',
      className: '8EF',
      setName: 'Set 2',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p7',
      dayOfWeek: 'thursday',
      subjectName: 'Science',
      className: '9GH',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
    // Friday
    {
      periodId: 'monday-p2',
      dayOfWeek: 'friday',
      subjectName: 'Science',
      className: '7IJ',
      setName: 'Set 2',
      subjectColor: '#9C27B0',
    },
    {
      periodId: 'monday-p4',
      dayOfWeek: 'friday',
      subjectName: 'Science',
      className: '8KL',
      setName: 'Set 1',
      subjectColor: '#9C27B0',
    },
  ],
};

// Mock teacher duties for demonstration purposes
// This maps teacherId to their duties (session duties and other duties)
export const mockTeacherDuties: Record<string, TeacherDuty[]> = {
  'teacher-001': [
    // Session duties (registration, break, lunch)
    { periodId: 'monday-p0', dayOfWeek: 'monday', dutyType: 'session' }, // Registration duty
    { periodId: 'monday-p3', dayOfWeek: 'monday', dutyType: 'session' }, // Break duty
    { periodId: 'monday-p6', dayOfWeek: 'wednesday', dutyType: 'session' }, // Lunch duty
    { periodId: 'monday-p0', dayOfWeek: 'friday', dutyType: 'session' }, // Registration duty
    // Other duties (SEND, Behavior, etc.)
    { periodId: 'monday-p5', dayOfWeek: 'monday', dutyType: 'other', dutyName: 'SEND' },
    { periodId: 'monday-p7', dayOfWeek: 'tuesday', dutyType: 'other', dutyName: 'Safeguarding' },
  ],
  'teacher-002': [
    // Session duties
    { periodId: 'monday-p0', dayOfWeek: 'tuesday', dutyType: 'session' }, // Registration duty
    { periodId: 'monday-p3', dayOfWeek: 'wednesday', dutyType: 'session' }, // Break duty
    { periodId: 'monday-p6', dayOfWeek: 'thursday', dutyType: 'session' }, // Lunch duty
    { periodId: 'monday-p3', dayOfWeek: 'friday', dutyType: 'session' }, // Break duty
    // Other duties
    { periodId: 'monday-p5', dayOfWeek: 'tuesday', dutyType: 'other', dutyName: 'Behavior' },
    { periodId: 'monday-p8', dayOfWeek: 'wednesday', dutyType: 'other', dutyName: 'Attendance' },
  ],
  'teacher-003': [
    // Session duties
    { periodId: 'monday-p0', dayOfWeek: 'monday', dutyType: 'session' }, // Registration duty
    { periodId: 'monday-p6', dayOfWeek: 'tuesday', dutyType: 'session' }, // Lunch duty
    { periodId: 'monday-p3', dayOfWeek: 'thursday', dutyType: 'session' }, // Break duty
    { periodId: 'monday-p9', dayOfWeek: 'friday', dutyType: 'session' }, // Dismissal duty
    // Other duties
    { periodId: 'monday-p7', dayOfWeek: 'monday', dutyType: 'other', dutyName: 'SEND' },
    { periodId: 'monday-p4', dayOfWeek: 'friday', dutyType: 'other', dutyName: 'Safeguarding' },
  ],
};

// Helper function to get scheduled lessons for a specific teacher
export const getTeacherScheduledLessons = (teacherId: string): TeacherScheduledLesson[] => {
  return mockTeacherScheduledLessons[teacherId] || [];
};

// Helper function to get duties for a specific teacher
export const getTeacherDuties = (teacherId: string): TeacherDuty[] => {
  return mockTeacherDuties[teacherId] || [];
};

export default mockTeacherScheduledLessons;
